<template>

  <main dir="rtl" class="page-wrapper d-flex justify-content-center align-items-center ">

    <!-- Page content -->
    <div class="container" style="margin-top: 3%;">
      <!-- Page content -->
      <div class="row">
        <!-- Main box -->
        <div class="col-lg-11 mb-5 m-auto" :style="isLoading ? 'filter: blur(0.2vw)' : ''">


          <div class="row align-items-center justify-content-center " style="margin-left: -5vw;">
            <div class="col-lg-3 login-form d-flex justify-content-center align-items-center">
              <form action="" class="form">
                <h1 class="mt-5">  سامانه جامع و یکپارچه بهفام    </h1>
                <div class="form-group mt-50 mb-4 mt-5-5">
                  <label style="font-size: 1vw" class="form-label"> نام‌ کاربری </label>
                  <input dir="ltr" style="width: 23vw;padding-top: 0.8vw;padding-left: 0.5vw;" v-model="username" class="form-input" type="text"/>
                </div>
                <div class="form-group mt-50 mb-4 mt-5-5">
                  <label style="font-size: 1vw;" class="form-label">رمز عبور</label>
                  <input
                      ref="passwordInput"
                      dir="ltr"
                      style="width: 23vw; padding-top: 0.8vw; padding-left: 0.5vw; "
                      v-model="password"
                      :type="passwordShow ? 'text' : 'password'"
                      class="form-input"
                      @focus="isFocused = true"
                      @blur="isFocused = false"
                  />

                  <template v-if="isFocused" style="position: relative; display: inline-block;">
                    <EyeOn
                        v-if="!passwordShow"
                        @mousedown.prevent="togglePassword"
                        style="width: 1.7vw; transform: translateX(-1.7vw) translateY(-5.1vw); cursor: pointer; position: absolute; top: 55%; right: 2%; transform: translateY(-50%);"
                    />
                    <EyeOff
                        v-if="passwordShow"
                        @mousedown.prevent="togglePassword"
                        style="width: 1.9vw; transform: translateX(-1.7vw) translateY(-5.1vw); cursor: pointer; position: absolute; top: 55%; right: 2%; transform: translateY(-50%);"
                    />
                  </template>
                </div>
                <div class="login__card--form__code mt-50 mb-4 mt-5-5"
                     style="display:flex; align-items: center">
                  <div class="form-group">
                    <label style="font-size: 1vw" class="form-label">کد امنیتی </label>
                    <input dir="ltr" style="width: 13.5vw;padding-top: 0.8vw;padding-left: 0.5vw;" v-model="inputCode" maxlength="6" class="form-input input__code"
                           type="text"/>
                  </div>

                  <div class="login__card--form__code--box shadow " style="border:0.1vw solid rgb(73,157,243); border-radius: 5px">
                    <img style="width: 100%; height: 3vw;border-radius: 5px" title="برای تغییر کد ضربه بزنید" class="" @click.prevent="generateCode"
                         :src="captcha_image" alt="">

                  </div>
                </div>

                <center>
                  <button style="position:relative; width: 23vw; display:flex !important;
  flex-direction: row-reverse;
  align-items: center;
  font-size: 1vw !important;
  justify-content: center;
  background-color: rgb(101, 169, 238) ;
  transform: translateX(0.2vw);
  color: #fff;
  border-color: rgb(101, 169, 238) ;
" @click.prevent="handleClick()" class="btn  btn-login mb-5 m-auto"  type="submit">ورود<span
                      v-show="isLoading" class="loader"></span></button>
                  <p v-if="false" class="text-info fw-bold cursor-pointer">رمز عبور خود را فراموش کرده ام؟</p>
                </center>

              </form>

            </div>
            <div class="col-lg-5 login-image d-flex justify-content-center align-items-center img_bg"
                 style="background-color: #fff; height: 40vw;position:relative;">
              <BehfamLOGOWhite style="transform: translateX(-2vw)" name=""/>
              <p style="position:absolute; bottom: 10vw; right: 15.5vw;   color: white">
                سامانه جامع و یکپارچه
              </p>
              <p style="position:absolute; bottom: 6.5vw; right: 15.2vw;font-size: 2vw; font-weight: bold; color: white">
                بـــــــهــــفــــــــــــــام
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal  -->

    <!-- modal  -->
    <!-- modal  -->
    <div class="modal__error" v-show="EmptycodeError">
      <div>
        <p>خطا</p>
        <p @click="EmptycodeError=!EmptycodeError">❌</p>
      </div>
      <div>
        <p>کد امنیتی را وارد کنید!</p>
        <button @click="EmptycodeError=!EmptycodeError">تایید</button>
      </div>
    </div>
    <!-- modal  -->
    <!-- modal  -->
    <div class="modal__error" v-show="UsernameError">
      <div>
        <p>خطا</p>
        <p @click="UsernameError=!UsernameError">❌</p>
      </div>
      <div>
        <p>{{ UsernameErrorM }}</p>
        <button @click="UsernameError=!UsernameError">تایید</button>
      </div>
    </div>
    <!-- modal  -->
    <!-- modal  -->

    <!-- modal  -->
  </main>
</template>

<script>
import CaptchaCode from 'vue-captcha-code';
import router from "@/router";
import cookies from "vue-cookies";
import {useToast} from "vue-toastification";
import EyeOn from "@/components/Docs/EyeOn.vue";
import EyeOff from "@/components/Docs/EyeOff.vue";
import BehfamLOGOWhite from "@/components/Icons/BehfamLOGOWhite.vue";

const toast = useToast();


export default {
  name: "Login",
  components: {
    BehfamLOGOWhite,
    EyeOff,
    EyeOn,
    CaptchaCode,
  },
  data() {
    return {
      username: null,
      password: null,
      code: '',
      inputCode: "",
      password_show: false,
      isFocused: false,
      codeError: false,
      EmptycodeError: false,
      passwordShow: false,
      UsernameError: false,
      UsernameErrorM: '',
      PasswordError: false,
      PasswordErrorM: false,
      isLoading: false,
      captcha_image: '',
      captcha_key: '',
    }
  },
  methods: {

    togglePassword() {
      this.passwordShow = !this.passwordShow;
      // وقتی آیکون کلیک شد، فوکوس را دوباره به فیلد برگردانیم
      this.$refs.passwordInput.focus();
    },
    async handleClick() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        if (!this.validateForm()) {
          return;
        }

        const response = await this.login();
        this.handleLoginResponse(response);
      } catch (error) {
        this.generateCode()
        this.showError(error.message);
      } finally {
        this.isLoading = false;
      }
    },

    validateForm() {
      if (!this.username) {
        this.showError('نام کاربری نمیتواند خالی باشد!');
        return false;
      }
      if (!this.password) {
        this.showError('پسورد نمیتواند خالی باشد!');
        return false;
      }
      if (this.inputCode.length !== 6) {
        this.showError('کد امنیتی وارد نشده است');
        return false;
      }
      return true;
    },

    showError(message) {
      toast.error(message);
    },

    async login() {
      const response = await fetch(`${this.base_url}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password,
          captcha_code: this.inputCode,
          captcha_key: this.captcha_key,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'خطای نامشخص در سرور');
      }

      return data;
    },

    handleLoginResponse(response) {
      if (response.error) {
        this.showError(response.error);
        this.inputCode = '';
        this.generateCode();
      } else if (response.token) {
        this.$store.commit('login', response.token);
        this.setCookies(response);
        router.push('/pishkhan');
      }
    },

    setCookies(response) {
      const cookieOptions = { expires: '3y' };

      if (response.mother_mode) {
        this.$cookies.set('mother_mode', response.mother_mode, cookieOptions);
      }
      if (response.is_mother) {
        this.$cookies.set('is_mother', response.is_mother, cookieOptions);
      }

      if (response.is_process_manager) {
  this.$cookies.set('is_process_manager', response.is_process_manager, cookieOptions);
} else {
  if (this.$cookies.isKey('is_process_manager')) {
    this.$cookies.remove('is_process_manager');
  }
}

      if (response.id) {
        this.$cookies.set('id_login', response.id, cookieOptions);
      }
      if (response.image) {
        this.$cookies.set('image_profile', response.image, cookieOptions);
      }
    },
    handleChange(code) {
      this.code = code
    },
    generateCode() {
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };

      fetch(`${this.base_url}/captcha`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            if (response.captcha_image) {
              this.captcha_image = response.captcha_image
            }
            if (response.captcha_key) {
              this.captcha_key = response.captcha_key
            }
          })
          .catch((error) => console.error(error));
    },

  }
  ,
  mounted() {


    $('input').focus(function () {
      $(this).parents('.form-group').addClass('focused');
    });

    $('input').blur(function () {
      var inputValue = $(this).val();
      if (inputValue == "") {
        $(this).removeClass('filled');
        $(this).parents('.form-group').removeClass('focused');
      } else {
        $(this).addClass('filled');
      }
    })
    this.generateCode()
  }
}
</script>

<style scoped lang="scss">
main{
  overflow-y: hidden !important;
}
.img_bg {
  background-image: url(../../assets/img/login.png);
  background-size: 32vw;
  background-repeat: no-repeat;
  background-position: center;
}

.bg__main {
  background-image: url(../../assets/img/bg_login.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  overflow-y: hidden;
}

/* CSS for floating label */
.form-group {
  position: relative;
}

.form-group + .form-group {
  margin-top: 1vw;
}

.form-label {
  position: absolute;
  right: 15px;
  top: 19px;
  color: #D6DDE3;
  z-index: 10;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
}

.focused .form-label {
  transform: translateY(-125%);
  font-size: .75em;
}

.form-input {
  margin-top: .5vw;
  position: relative;
  padding: 1vw 0px 5px 0;
  width: 70vw;
  outline: 0;
  border: 0;
  box-shadow: 0 1px 0 0 #D6DDE3;
  transition: box-shadow 150ms ease-out;
  border-bottom: .3vw solid #D6DDE3;
  background: transparent;
}

.form-input:focus {
  box-shadow: 0 2px 0 0 #D6DDE3;
}

.form-input.filled {
  box-shadow: 0 2px 0 0 #D6DDE3;
}

.form-group {
  background-color: unset;
  box-shadow: unset;
  border: unset;;
}

.login__card--form__code--box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5vw;
  cursor: pointer;
  user-select: none;
  font-weight: bolder;
  margin-top: 1vw;

}

.mt-5-5 {
  margin-top: 3vw !important;
}

input {
  font-size: 1vw;
}

.loading {
  background-color: rgba(#fff, .5);
  width: 82.5vw;
  height: 42.40vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 104px 58px 64px 54px;
  z-index: 9999;

}

.modal__error {
  background-color: #cfe4f1;
  width: 30vw;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1.3vw;
  padding: 1.1vw;
  box-shadow: 0 0 3px 2px #eee;

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > p {
      font-family: Shabnam;
      font-size: 1.1vw;

      &:nth-child(2) {
        cursor: pointer;
      }

    }
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > p {
      font-size: 1.1vw;
      font-family: Shabnam;

    }

    & > button {
      font-size: 1vw;
      width: 8vw;
      background-color: #D6DDE3;
      color: #fff;
      border: unset;
      border-radius: .5vw;
      height: 2vw;
      margin-top: 2.5vw;
      margin-bottom: 2.5vw;
      cursor: pointer;
      font-family: Shabnam;


    }
  }
}
.btn-login{
  margin-top: 4vw !important;
}
.btn-login:hover{
  background: #499DF3 !important;
  color: white;
}
</style>